import { render, staticRenderFns } from "./SimplatorPrice.vue?vue&type=template&id=32633eb4&scoped=true&"
import script from "./SimplatorPrice.vue?vue&type=script&lang=ts&"
export * from "./SimplatorPrice.vue?vue&type=script&lang=ts&"
import style0 from "./SimplatorPrice.vue?vue&type=style&index=0&id=32633eb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32633eb4",
  null
  
)

export default component.exports